import uriTools from './uri-tools'
import cookies from 'js-cookie';
import {get, set} from './localstorage-with-expire'

function getSavedKey()
{
    const refKeyName = window.euPortalConfig.referrer.key;
    const refKeyFromCookie = cookies.get(refKeyName);
    if (refKeyFromCookie) {
        return parseInt(refKeyFromCookie);
    }

    //localstorage not used now as cookie is set in backend now (ReferrerListener)
    //code kept in case if we move to JS frontend
    const refKeyFromLocalStorage = get(refKeyName);
    if (refKeyFromLocalStorage) {
        return parseInt(refKeyFromLocalStorage);
    }

    return null;
}

function saveRefKey(refKey)
{
    const refCfg = window.euPortalConfig.referrer;
    //create cookie
    cookies.set(
        refCfg.key,
        refKey,
        { path: '/', domain: '.' + window.euPortalConfig.domain, expires: refCfg.expires/24/60/60 }
    );
    //save to localstorage
    set(refCfg.key, refKey, refCfg.expires);
}

export function fillReferrer() {
    const refValue = getSavedKey();
    if (refValue) {
        //fill personal and business signup for with referrer key
        document.querySelector('#referrer_key').value = refValue;
    }
}

export default function referrerHandler() {
    const refKey = window.euPortalConfig.referrer.key;
    const queryData = uriTools.deserializeQueryStringToObject();
    if (queryData[refKey]) {
        const newRefId = parseInt(queryData[refKey]);
        const savedRefId = getSavedKey();
        if (savedRefId === null || savedRefId !== newRefId) {
            saveRefKey(queryData[refKey]);
        }
    }
}
